import Week from '@rover/utilities/Week/weekContextless';

export type WeekdayQueryParameter = {
  paramName: string;
  index: number;
};

// array of WeekdayQueryParameter objects
export const WEEKDAY_PARAMS: WeekdayQueryParameter[] = Week.days().map((day, index) => ({
  paramName: Week.lowerLongName(index),
  index,
}));

// array of WeekdayQueryParameter objects in US English locale
export const WEEKDAY_ENGLISH_PARAMS: WeekdayQueryParameter[] = Week.days().map((day, index) => ({
  paramName: Week.lowerEnglishNameUSLocale(index),
  index,
}));
